var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElAlert',{attrs:{"effect":"dark","show-icon":"","type":"warning"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n    "+_vm._s(_vm.hint)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }